module.exports = {
    kolmatTitle: "KOL MKT",
    dashboard:'Dashboard',
    dashboard2:'Dashboard',
    report:'Report',
    reportResult: 'Closing Report',
    setting:'Setting',
    kolSettingBasicData: 'Basic Data',
    kolMktSettingReportResult: 'Closing Report',
    cpmTrendsInLast7Days: 'View Counts Trends in Last 7 Days',
    dimension: 'Dimension',
    index: 'Index',
    influencer: 'Influencer',
    campaign: 'Campaign',
    platform: 'Platform',
    nearyear:'Nearly 7 Days View Counts',
    launchInTime: 'Launch-in time',
    viewCounts: 'View counts',
    cpm: 'CPM',
    product:'Product',
    campaigns:'Campaign',
    affcost:'Aff Cost',
    samelinkdd:'The date under the same video link cannot be repeated. Please reset the date',
    profit:'Profit',
    vcr:'The video link cannot be repeated',
    noadd:'The data has not been filled in and new data cannot be created',
    profitlv:'Profit rate',
    kolTop5Campaigns: 'Latest Top 5 Influencers',
    enterAdvertiser: 'Please enter advertiser',
    enterCorAdv:'Please enter the correct advertiser',
    pldele:'Please select the data to be deleted.',
    enterInfluencer: 'Please enter influencer',
    enterCampaign: 'Please enter Campaign',
    enterPlatform: 'Please enter platform',
    kolTrackSettingProduct:'Product Setting',
    kolTrackSettingMarketing:'Project Setting',
    kolmustone:'At least one influencerId must be selected',
    kolMktSettingKolUpload:'KOL Upload',
    entryDate:'Import Date',
    logo:'Logo',
    kolname:'KOL Name',
    channel:'Channel Source',
    source:'Source',
    state:'Status',
    kollink:'KOL Link',
    reportPrice:'Client Price',
    bloggerPrice:'Reference Cost',
    mp:'MP',
    othercontent:'Other ways of contact',
    progress:'Development Progress',
    lunch:'Launch Status',
    Unpublished:'Unpublished',
    Publishing:'Publishing',
    Published:'Published',
    Publishingfailed:'Publish failed',
    competingProducts:'Competing Products',
    kolType:'KOL Type',
    quotedVideoType:'Video Type',
    introduce:'Recommend Reason',
    promotionCase:'Case Description',
    KOLQU:'KOL Details',
    KOLbasice:'KOL Basic Information',
    priceInfo:'Price Information',
    startLuanch:'Start launch',
    baiceInfo:'Basic Information',
    promoteInfo:'Advance Information',
    notget:'KOL basic information is not available',
    lengths:'Length should be',
    to:'to',
    betwwen:'',
    male:'Male',
    female:'Female',
    exportIn:'Import KOLs',
    dfile:'KOL Template',
    lunchSure:'Sure to launch?',
    downfail:'Download failed',
    EMPTYS:'Upload data is empty',
    linknone:'KOL link cannot be empty',
    kolmkthave:'KOL link already exists',
    pleasechange:'Please upload again after modification',
    linkempty:'kolUrl can not be empty,please check your fill content',
    ti1:'Please fill in the kol link',
    ti2:'Not a correct link form',
    ti3:'Incorrect link channel',
    ti4:'Link channel content is missing module type',
    ti5:'The content of the link channel is lack of kol ID',
}




// WEBPACK FOOTER //
// ./src/i18n/modules/kolmkt/en.js